import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/webFlashSales` // Adjust if backend URL differs

// ---------------------------------------------
// Create Flash Sale (Vendor)
// ---------------------------------------------
export const createFlashSaleApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/create`, formData)
}

// ---------------------------------------------
// Update Flash Sale
// ---------------------------------------------
export const updateFlashSaleApi = (id, formData) => {
  return axiosInstance.put(`${serverUrl}/update/${id}`, formData)
}

// ---------------------------------------------
// Delete Flash Sale
// ---------------------------------------------
export const deleteFlashSaleApi = (id) => {
  return axiosInstance.delete(`${serverUrl}/delete/${id}`)
}

// ---------------------------------------------
// Get Flash Sale by ID (public or vendor)
// ---------------------------------------------
export const getFlashSaleByIdApi = (id) => {
  return axiosInstance.get(`${serverUrl}/get/${id}`)
}

// ---------------------------------------------
// Get Flash Sales for Vendor (Dashboard)
// ---------------------------------------------
export const getVendorFlashSalesApi = (vendorId) => {
  return axiosInstance.get(`${serverUrl}/vendor/${vendorId}`)
}

// ---------------------------------------------
// Admin: Get All Flash Sales (search & pagination)
// ---------------------------------------------
export const getAllFlashSalesApi = (queryParams = {}) => {
  const { q = "", page = 1, perPage = 20, status = "" } = queryParams

  const query = `q=${encodeURIComponent(
    q
  )}&page=${page}&perPage=${perPage}&status=${status}`

  return axiosInstance.get(`${serverUrl}/all?${query}`)
}

// ---------------------------------------------
// Public: Only Active Flash Sales
// ---------------------------------------------
export const getPublicActiveFlashSalesApi = () => {
  return axiosInstance.get(`${serverUrl}/public/active`)
}

// ---------------------------------------------
// Add or Update Flash Sale Product
// ---------------------------------------------
export const addOrUpdateFlashSaleProductApi = (id, formData) => {
  return axiosInstance.post(`${serverUrl}/product/add-update/${id}`, formData)
}

// ---------------------------------------------
// Remove Product From Flash Sale
// ---------------------------------------------
export const removeFlashSaleProductApi = (id, formData) => {
  return axiosInstance.post(`${serverUrl}/product/remove/${id}`, formData)
}

export const getAdminFlashSalesApi = (params = {}) => {
  return axiosInstance.get(`${serverUrl}/getSalesAdmin`, { params })
}

// ---------------------------------------------
// Export as a single service object
// ---------------------------------------------
const FlashSalesService = {
  createFlashSale: createFlashSaleApi,
  updateFlashSale: updateFlashSaleApi,
  deleteFlashSale: deleteFlashSaleApi,
  getFlashSaleById: getFlashSaleByIdApi,
  getVendorFlashSales: getVendorFlashSalesApi,
  getAllFlashSales: getAllFlashSalesApi,
  getPublicActiveFlashSales: getPublicActiveFlashSalesApi,
  addOrUpdateProduct: addOrUpdateFlashSaleProductApi,
  removeProduct: removeFlashSaleProductApi,
  getAdminFlashSales: getAdminFlashSalesApi
}

export default FlashSalesService
